/* file description */
import { btnListType, pageObj, BUTTONLIST } from '../consts';
import type { pageStatusType } from '@/components/sp-centre-asset/index.type';
import useMetaStore from '@/store/useMetaStore';
import useValuesStore from '@/store/useValuesStore';
import { jsonataFactory } from '@/utils';


interface ConfigFilterPropsType {
  btnList: btnListType;
}

export const useConfigFilter = ({
  btnList,
}: ConfigFilterPropsType) => {
  const { pageType, taskInfo, pageConfig } = useMetaStore();
  const { values } = useValuesStore();

  const filterBtnConfig: any[] = btnList;
  const pList = pageConfig.rulePageValue?.filter((item: any) => item?.events?.isMakeBtn === true && item?.visible !== false) || [];

  // 走过程进行过滤
  if (pList.length !== 0) {
    pList?.forEach((rule) => {
      if (!rule?.rules?.rules_expression) return;
      const expression = jsonataFactory(rule?.rules?.rules_expression);
      const resultTag = expression.evaluate(values || {});
      // // 判断编辑页的按钮
      // for (const [key, isShow] of Object.entries(rule.events?.btnConfig?.['detail-bottom'] || {})) {
      //   // 按钮显示的条件不成立 或 按钮不显示的条件成立 需要隐藏按钮
      //   if ((isShow && !resultTag) || (!isShow && resultTag)) {
      //     filterBtnConfig = filterBtnConfig.filter(k => k !== key);
      //   }
      // }
      // // 判断流程按钮
      // for (const [key, isShow] of Object.entries(rule.events?.btnConfig?.process || {})) {
      //   // 按钮显示的条件不成立 或 按钮不显示的条件成立 需要隐藏按钮
      //   if ((isShow && !resultTag) || (!isShow && resultTag)) {
      //     filterBtnConfig = filterBtnConfig.filter(k => k !== key);
      //   }
      // }
      if (!resultTag) return;
      // 判断编辑页的按钮
      for (const [key, value] of Object.entries(rule.events?.btnConfig?.['detail-bottom'] || {})) {
        if (!value) continue;
        const targetBtn = filterBtnConfig.findIndex((item) => item == key);
        if (targetBtn < 0) {
          filterBtnConfig.push(key);
        }
      }
      // 判断流程按钮
      for (const [key, value] of Object.entries(rule.events?.btnConfig?.process || {})) {
        if (!value) continue;
        const targetBtn = filterBtnConfig.findIndex((item) => item == key);
        if (targetBtn < 0) {
          filterBtnConfig.push(key);
        }
      }
    });
  }


  const list = BUTTONLIST.map((b) => {
    if (filterBtnConfig.includes(b.type)) {
      return b;
    }
  }).filter((item) => item !== undefined);

  return {
    optionList: list,
  };
};
